'use client';

import { usePathname } from 'next/navigation';
import { AuthProvider } from '@/hooks/use-auth';
import Navigation from '@/components/navigation';
import { BackgroundProvider } from '@/components/background-provider';

interface LayoutContentProps {
  children: React.ReactNode;
}

export default function LayoutContent({ children }: LayoutContentProps) {
  const pathname = usePathname();

  // Check if current path is an admin route
  const isAdminRoute = pathname?.startsWith('/admin');
  const isFounderProfileRoute = pathname?.startsWith('/contact/');

  return (
    <>
      {isAdminRoute ? (
        // Admin routes - no AuthProvider needed
        <>
          <main className="flex-1">{children}</main>
        </>
      ) : (
        // Regular routes - include AuthProvider
        <AuthProvider>
          <BackgroundProvider>
            {!isFounderProfileRoute && <Navigation />}
            <main className="flex-1">{children}</main>
          </BackgroundProvider>
        </AuthProvider>
      )}
    </>
  );
}
